import React from 'react'
import Navbar from '../components/Navbar'
import SearchCoin from '../components/SearchCoin'
const Cryptocurrency = () => {
    return (
        <div className=' bg-black text-white min-h-screen'>
            <Navbar />
            <SearchCoin />

        </div>
    )
}

export default Cryptocurrency
